import {useQuery} from "@apollo/client";
import {GeoSuggestQuery, GET_GEOSUGGEST} from "@App/graphql/queries";

/**
 * A custom hook that queries geo suggests from the api
 * @param search
 * @param lat
 * @param lon
 * @param place
 */
export const useGeoSuggest = ({search = null, lat = null, lon = null, place = null} = {}) => {
    const {loading, data, error} = useQuery<GeoSuggestQuery>(GET_GEOSUGGEST, {
        variables: {
            search: search.toLowerCase(),
            placeId: place && (!search || search === place.name)
                ? place.id
                : null,
            lat: lat,
            lon: lon,
        },
        fetchPolicy: "no-cache",
        skip: (search.length <= 2 && !lat) || (place && place.lat && place.name === search)
    })

    return {
        loading: loading,
        error: error,
        suggests: data ? data.geosuggest : null
    }
}


